import { useMyOrderById } from "api/Client/product";
import { Spinner } from "components";
import { useEffect } from "react";
import { FaCheck, FaTimes, FaClock, FaCreditCard } from "react-icons/fa";
import { MdReceiptLong, MdNumbers } from "react-icons/md";
import { SlCalender } from "react-icons/sl";
import { useNavigate } from "react-router-dom";
import ClientActionModal from "../ClientActionModal/ClientActionModal";
import { image_host } from "config/api_host";

export default function MyOrderModal({ isOpen, toggle, orderId, url }) {
  const navigate = useNavigate();
  const {
    data: currentOrder,
    isSuccess: currentOrderIsSuccess,
    isFetching: currentOrderIsFetching,
  } = useMyOrderById(orderId);

  useEffect(() => {
    return () => url && navigate("/cp/orders", { replace: true });
  }, [url, navigate]);

  const openImageInPopup = (imgUrl, title) => {
    const width = 800;
    const height = 600;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    const newWindow = window.open(
      "",
      title,
      `width=${width},height=${height},top=${top},left=${left}`
    );

    if (newWindow) {
      newWindow.document.write(`
        <html><body style="margin:0;display:flex;justify-content:center;align-items:center;bg:#000;">
          <img src="${imgUrl}" style="max-width:100%;max-height:100%;object-fit:contain;" />
        </body></html>`);
    }
  };

  return (
    <ClientActionModal
      open={isOpen}
      close={toggle}
      size="medium"
      title={"تفاصيل الفاتورة"}
    >
      {currentOrderIsFetching ? (
        <div className="flex justify-center items-center py-20">
          <Spinner sm />
        </div>
      ) : (
        currentOrderIsSuccess && (
          <div className="space-y-6 my-2 font-[Tajawal]" dir="rtl">
            {/* بطاقة الفاتورة العلوية - نمط البطاقة البنكية */}
            <div className="relative overflow-hidden bg-gray-100 dark:bg-white/5 border border-white dark:border-white/10 p-6 rounded-[2.5rem] shadow-xl transition-all">
              <div className="flex justify-between items-start mb-8">
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
                    فاتورة شراء
                  </h2>
                  <p className="text-xs text-mainLight font-bold tracking-widest mt-1 uppercase">
                    Al Alamia Laptop
                  </p>
                </div>
                <StatusBadge state={currentOrder.data.status} />
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
                <InfoItem
                  icon={<MdNumbers />}
                  label="رقم العملية"
                  value={currentOrder.data.id}
                />
                <InfoItem
                  icon={<MdReceiptLong />}
                  label="رقم الفاتورة"
                  value={currentOrder.data.order_number}
                />
                <InfoItem
                  icon={<SlCalender />}
                  label="التاريخ"
                  value={currentOrder.data.created_at}
                />
                <InfoItem
                  icon={<FaCreditCard />}
                  label="وسيلة الدفع"
                  value={currentOrder.data.payment_method}
                />
                <InfoItem
                  label="إجمالي المبلغ"
                  value={`${Number(
                    Math.abs(currentOrder.data.total_amount)
                  ).toLocaleString()} USD`}
                  isHighlight
                />
                <InfoItem
                  label="المبلغ المدفوع"
                  value={`${Number(
                    Math.abs(currentOrder.data.paid_amount)
                  ).toLocaleString()} ${currentOrder.data.currency}`}
                  isHighlight
                />
              </div>

              {/* زخرفة خفيفة في الخلفية */}
              <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-mainLight/5 rounded-full blur-3xl" />
            </div>

            {/* جدول المنتجات */}
            <div className="space-y-3">
              <h5 className="text-sm font-bold text-gray-400 mr-4 flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-mainLight" /> تفاصيل
                الفاتورة
              </h5>
              <div className="overflow-hidden rounded-[2rem] border border-gray-200 dark:border-white/5 bg-gray-50/50 dark:bg-white/5 backdrop-blur-md">
                <table className="w-full text-sm text-right">
                  <thead className="text-[10px] uppercase text-gray-400 border-b border-gray-200 dark:border-white/5">
                    <tr>
                      <th className="px-6 py-4">المنتج</th>
                      <th className="px-6 py-4">السعر</th>
                      <th className="px-6 py-4 text-center">الكمية</th>
                      <th className="px-6 py-4">الإجمالي</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 dark:divide-white/5 text-gray-700 dark:text-gray-200">
                    {currentOrder.data.items.map((item, key) => (
                      <tr
                        key={key}
                        className="hover:bg-white dark:hover:bg-white/5 transition-colors"
                      >
                        <td className="px-6 py-4 font-bold">
                          {item.product_name}
                        </td>
                        <td className="px-6 py-4 text-xs">
                          ${item.price_at_time}
                        </td>
                        <td className="px-6 py-4 text-center">
                          <span className="bg-mainLight/10 text-mainLight px-3 py-1 rounded-lg font-bold text-xs">
                            {item.quantity}
                          </span>
                        </td>
                        <td className="px-6 py-4 font-bold">
                          ${item.price_at_time * item.quantity}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* الملاحظات أو سبب الرفض */}
            {currentOrder.data.reason && (
              <div className="p-4 rounded-2xl bg-red-50 dark:bg-red-500/5 border border-red-200 dark:border-red-500/20">
                <h5 className="text-xs font-bold text-red-600 dark:text-red-400 mb-1 flex items-center gap-2">
                  <FaTimes />{" "}
                  {currentOrder.data.order_state === "rejected"
                    ? "سبب الرفض"
                    : "ملاحظات الإدارة"}
                </h5>
                <p
                  className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed"
                  dangerouslySetInnerHTML={{
                    __html: currentOrder.data.reason?.replace(/\n/g, "<br />"),
                  }}
                />
              </div>
            )}

            {/* صورة الإيصال */}
            <div className="space-y-3">
              <h5 className="text-sm font-bold text-gray-400 mr-4 flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-mainLight" /> إثبات
                الدفع
              </h5>
              <div
                onClick={() =>
                  openImageInPopup(
                    `${image_host}/${currentOrder.data.payment_receipt}`,
                    "وصل الدفع"
                  )
                }
                className="relative group cursor-pointer overflow-hidden rounded-[2rem] border border-dashed border-gray-300 dark:border-white/20 p-2"
              >
                <img
                  src={`${image_host}/${currentOrder.data.payment_receipt}`}
                  alt="Receipt"
                  className="w-full h-48 object-cover rounded-[1.5rem]   transition-all duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
                  <span className="text-white text-xs font-bold bg-mainLight px-4 py-2 rounded-full">
                    عرض الصورة كاملة
                  </span>
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </ClientActionModal>
  );
}

// مكون فرعي لعرض تفاصيل المعلومات
function InfoItem({ icon, label, value, isHighlight = false }) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-[10px] text-gray-400 font-bold flex items-center gap-1">
        {icon} {label}
      </span>
      <span
        className={`text-sm font-bold ${
          isHighlight ? "text-mainLight" : "text-gray-700 dark:text-gray-200"
        }`}
      >
        {value}
      </span>
    </div>
  );
}

// مكون شارة الحالة
function StatusBadge({ state }) {
  const config = {
    pending: {
      label: "انتظار",
      color: "text-amber-600 bg-amber-500/10",
      icon: <FaClock />,
    },
    paid: {
      label: "مكتمل",
      color: "text-green-600 bg-green-500/10",
      icon: <FaCheck />,
    },
    cancelled: {
      label: "مرفوض",
      color: "text-red-600 bg-red-500/10",
      icon: <FaTimes />,
    },
  };
  const status = config[state] || config.pending;
  return (
    <div
      className={`flex items-center gap-2 px-4 py-1.5 rounded-full text-[10px] font-bold ${status.color}`}
    >
      {status.icon} {status.label}
    </div>
  );
}
